import { Client } from 'urql';
import { streetPageQuery } from './streetPageQuery';

export const fetchStreetPage = async ({ client, slug }: { client: Client; slug: string }) => {
  const { data, error } = await client.query(streetPageQuery, { slug }).toPromise();
  return { data, error };
};
